import React from 'react';
import './style.scss';
import Header from '../header/';
import Tracker from '../../../genesys/tracker';
import { LAYERS } from '../../layers/types';
import * as MainActions from '../../main/actions';
import { getWidgetDisplay } from '../../layers/widget/helpers';

export default class MaximizedFrame extends React.Component {
    constructor(props) {
        super(props);
        this.showAfter = props.delays && props.delays.showAfter ? props.delays.showAfter : 0;
        this.hideAfter = props.delays && props.delays.hideAfter ? props.delays.hideAfter : 0;
        this.componentTimeout = null;
        this.state = {
            visibility: 'hidden'
        };
    }

    componentDidMount() {
        if (this.showAfter > 0) {
            this.componentTimeout = setTimeout(() => this.show(), this.showAfter * 1000);
        } else {
            this.show();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.componentTimeout);
    }

    show() {
        this.setState({ visibility: 'visible' });
        if (this.hideAfter > 0) {
            this.componentTimeout = setTimeout(() => this.hide(), this.hideAfter * 1000);
        }
        MainActions.updateMainLayer({
            layer: LAYERS.WIDGET,
            iFrameMode: getWidgetDisplay(),
            source: 'maximizedFrame'
        });
    }

    hide() {
        Tracker.timeOutInvite();
        this.props.events.close('maximizedCountdownTimeout');
    }

    render() {
        const { title, type, events, background, children } = this.props,
            classes =
                this.state.visibility +
                ' maximized-view ' +
                (background ? background + ' ' : '') +
                (type === 'small'
                    ? 'widget-frame-maximized-small'
                    : type === 'large'
                        ? 'widget-frame-maximized-large'
                        : '');
        return (
            <div className={classes}>
                <div className="title-bar">
                    <Header
                        title={title}
                        events={{
                            minimize: events.minimize,
                            close: events.close
                        }}
                    />
                </div>
                <div className="content">{children}</div>
            </div>
        );
    }
}
